export default __webpack_public_path__ + "static/media/Headline_Icon.5b078188.svg";